module.exports = __webpack_public_path__ + "img/yingbi46.54dce060.png";